module.exports = __webpack_public_path__ + "media/auth/resend_confirmation-5f47ed39.svg";